<!--
 * @Author: your name
 * @Date: 2020-08-16 09:53:51
 * @LastEditTime: 2022-11-07 16:03:46
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/form/form.vue
-->
<template>
  <form>
    <slot></slot>
  </form>
</template>
<script>
export default {
  name: 'PyForm',
  props: {
    model: {
      type: Object,
    },
    rules: {
      type: Object,
    },
  },
  provide() {
    return {
      form: this,
    }
  },
  data() {
    return {
      fields: [],
    }
  },
  methods: {
    // Expose method: reset all data
    // 公开方法：重置全部的数据
    resetFields() {
      this.fields.forEach(field => {
        field.resetField()
      })
    },
    // Public method: all verification data, support Promise
    // 公开方法：校验全部的数据，支持 Promise
    validate(callback) {
      return new Promise(resolve => {
        let valid = true
        let count = 0
        this.fields.forEach(field => {
          field.validate('', errors => {
            if (errors) {
              valid = false
            }
            if (++count === this.fields.length) {
              // Complete All
              // 全部完成
              resolve(valid)
              if (typeof callback === 'function') {
                callback(valid)
              }
            }
          })
        })
      })
    },
  },
  created() {
    this.$on('on-form-item-add', field => {
      if (field) this.fields.push(field)
    })
    this.$on('on-form-item-remove', field => {
      if (field.prop) this.fields.splice(this.fields.indexOf(field), 1)
    })
  },
}
</script>